import React, { useContext } from 'react';
import { connect } from 'react-redux';

// components
import { Type, Button, Typography, Icon } from '@americanexpress/aqx-components';
// selectors
import { makeGetHighlights, makeGetViewMoreButton } from '../redux';
import { QuickViewContext } from './Tile';
// utiles
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

// styles
import styles from '../__styles__/highlights.scss?modules';

const Highlights = ({ highlights, viewMoreCta, shortName }) => {
  const { setIsQuickViewOpen, isQuickViewOpen } = useContext(QuickViewContext);
  return (
    <div className={styles.container}>
      <h3 className={styles.header}>Highlights</h3>
      <ul>
        {highlights.map(highlight => {
          return (
            <li key={highlight.text}>
              <Icon
                directory="dls"
                imageName={highlight.icon.imageName}
                className={styles.icon}
              />
              <div className={styles.textAndFlag}>
                <Typography className={styles.text} $size={15} $lineHeight={22}>
                  {highlight.text}
                </Typography>
                {highlight.flag && (
                  <span className={styles.flag}>{highlight.flag}</span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      <Button
        $type={Type.Tertiary}
        onClick={() => {
          setIsQuickViewOpen(!isQuickViewOpen);
          sendDTMClickEvent({
            ...viewMoreCta?.dtm,
            eventAsset: `${viewMoreCta?.dtm?.eventAsset}${shortName}`
          });
        }}
        className={styles.button}
      >
        <span>{viewMoreCta?.text}</span>
        <Icon
          directory="dls"
          imageName={`dls-icon-${isQuickViewOpen ? 'up' : 'down'}-filled`}
        />
      </Button>
    </div>
  );
};

const mapStateToProps = () => {
  const getHighlights = makeGetHighlights();
  const getViewMoreCta = makeGetViewMoreButton();
  return (state, { shortName }) => ({
    highlights: getHighlights(state, shortName),
    viewMoreCta: getViewMoreCta(state, shortName),
    shortName
  });
};

export default connect(mapStateToProps)(Highlights);
